import {
  DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_FAILURE,
  DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_REQUEST,
  DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_FAILURE,
  DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_REQUEST,
  DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_FAILURE,
  DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_REQUEST,
  DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_FAILURE,
  DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_REQUEST,
  DOCUMENT_PROGRESS__REQUEST_CANCEL_FAILURE,
  DOCUMENT_PROGRESS__REQUEST_CANCEL_REQUEST,
  DOCUMENT_PROGRESS__SIGNING_REMIND_FAILURE,
  DOCUMENT_PROGRESS__SIGNING_REMIND_REQUEST,
} from '@app/store/actionTypes';
import { DocumentProgressAction } from '@app/store/documentProgress/actions';

type DocumentProgressErrorState = string;

const initialState: DocumentProgressErrorState = '';

export default function reducer(
  state: DocumentProgressErrorState = initialState,
  action: DocumentProgressAction
) {
  switch (action.type) {
    case DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_REQUEST:
    case DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_REQUEST:
    case DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_REQUEST:
    case DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_REQUEST:
    case DOCUMENT_PROGRESS__REQUEST_CANCEL_REQUEST:
    case DOCUMENT_PROGRESS__SIGNING_REMIND_REQUEST:
      return initialState;
    case DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_FAILURE:
    case DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_FAILURE:
    case DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_FAILURE:
    case DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_FAILURE:
    case DOCUMENT_PROGRESS__REQUEST_CANCEL_FAILURE:
    case DOCUMENT_PROGRESS__SIGNING_REMIND_FAILURE: {
      return action.payload.message;
    }
    default:
      return state;
  }
}
